import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import {
  CategoryItem,
  CategorySelectorComponent,
} from '../category-selector/category-selector.component';

import { FactorService } from 'src/app/factors/services/factor.service';
import { ActivityFormService } from 'src/app/trip-calculator/services/activity-form.service';

@Component({
  selector: 'app-select-custom-factor',
  imports: [TranslocoPipe, CategorySelectorComponent],
  templateUrl: './select-custom-factor.component.html',
})
export class SelectCustomFactorComponent implements OnInit, OnDestroy {
  activityFormService = inject(ActivityFormService);

  factorService = inject(FactorService);

  items: CategoryItem[] = [];

  ngOnInit() {
    this.initializeItems();
    this.activityFormService.createCustomFactorControl();
  }
  ngOnDestroy() {
    this.activityFormService.destroyCustomFactorControl();
  }

  initializeItems() {
    this.items = [];
    for (const factor of this.activityFormService.activityFactor()) {
      this.items.push({
        value: factor.id,
        label: factor.name,
      });
    }
  }

  get value() {
    const value = this.activityFormService.activityForm.get(
      'customEmissionFactorId',
    )?.value;
    return value ? value : '';
  }

  set value(value: string) {
    this.activityFormService.activityForm
      .get('customEmissionFactorId')
      ?.setValue(value);
  }
}
